import { mdiBookAccountOutline } from '@mdi/js'

export default {
  title: 'Certificate Teacher',
  to: 'certificate-teacher',
  icon: mdiBookAccountOutline,
  resource: 'CertificateTeacher',
  action: 'read',
}
